import React from 'react';
import ImageSectionsList from './ImageSectionsList';
import { ImageGroup, ImageSectionsListClasses } from '../../types';

interface LeftSectionProps {
  proNumber?: string;
  imageGroups: ImageGroup[];
  selectedKey?: string;
  onSelect: (key: string) => void;
  hasIframe?: boolean;
  onLoadProImages?: () => void;
  loading?: boolean;
  error?: string | null;
  classes: any;
}

const LeftSection: React.FC<LeftSectionProps> = ({
  proNumber,
  imageGroups,
  selectedKey,
  onSelect,
  hasIframe,
  onLoadProImages,
  loading,
  error,
  classes,
}) => {
  const imageSectionsListClasses: ImageSectionsListClasses = {
    listSubHeader: classes.listSubHeader,
    listItem: classes.listItem,
    listItemSelected: classes.listItemSelected,
    listContainer: classes.listContainer,
  };

  return (
    <div className={classes.imageListContainer}>
      <ImageSectionsList
        proNumber={proNumber}
        imageGroups={imageGroups}
        selectedKey={selectedKey}
        onSelect={onSelect}
        hasIframe={hasIframe}
        onLoadProImages={onLoadProImages}
        loading={loading}
        error={error}
        classes={imageSectionsListClasses}
      />
    </div>
  );
};

export default LeftSection;
